export default function (errorPayload, isAdmin = false) {
  switch (errorPayload.code) {
    case 12:
      return 'E-Mail oder Passwort inkorrekt';
    case 19:
      return 'Passwort inkorrekt';
    case 18:
      return 'Account ist bereits aktiviert';
    case 17:
      return 'Account nicht aktiviert - bitte klicken Sie auf den Link in ihrer Willkommens-E-Mail';
    case 16:
      return 'Zugang gesperrt';
    case 13:
      return 'Es gab ein Problem mit Ihrer Session weswegen wir Sie abgemeldet haben, bitte versuchen Sie sich neu anzumelden. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an support@standortmonitor.net';
    case 15:
      return 'Lizenz abgelaufen';
    case 20:
      return 'Bereits vorhanden';
    default:
      // if (store.strict === true) {
      //  this.error = `Dev-Error: ${res.response.data.msg}`;
      // } else {
      if (isAdmin) {
        console.log(errorPayload);
        const errorMsg = errorPayload.error_info;
        let errorMsgStr = 'Server-Side Error: <ul>';
        Object.keys(errorMsg).forEach((errorMsgKey) => {
          if (Object.prototype.hasOwnProperty.call(errorMsg, errorMsgKey)) {
            errorMsgStr += `<li> ${errorMsgKey}: ${errorMsg[errorMsgKey]}</li>`;
          }
        });
        return `${errorMsgStr}</ul>`;
      }
      return 'Ein interner Fehler ist aufgetreten, bitte versuchen Sie es später erneut. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an support@standortmonitor.net';
    // }
  }
}
